import ApiModel from "../APIModel";

export default class AppsCategories extends ApiModel {
  constructor() {
    super("apps_categories");
  }
}
